import React from 'react';
import { Link } from 'react-router-dom';

const Pricing: React.FC = () => (
  <section className="container section animate-fadeInUp">
    <h2>Simple Pricing</h2>
    <div className="pricing-grid">
      <div className="pricing-card">
        <h3>Completely Free</h3>
        <p>£0/month during our introductory period</p>
      </div>
      <div className="pricing-card">
        <h3>Affordable</h3>
        <p>Under £49/month when fully launched</p>
      </div>
      <div className="pricing-card">
        <h3>Flexible</h3>
        <p>Cancel anytime, no hidden fees</p>
      </div>
      <div className="pricing-card">
        <h3>Exclusive Perks</h3>
        <p>Early users receive lifetime discounts</p>
      </div>
    </div>
    <div className="section-cta">
          <Link to="/get-started" className="cta">Get started for free</Link>
        </div>
  </section>
);

export default Pricing;
